import request from '@/utils/request'

export function getPaperList(params) {
    return request({
        url: '/zhixue/getPaperList',
        method: 'post',
        params: params
    })
}

export function tips(params) {
    return request({
        url: '/zhixue/tips',
        method: 'post',
        params: params
    })
}

export function getAIImgInfo(params) {
    return request({
        url: '/zhixue/getAIImgInfo',
        method: 'post',
        params: params
    })
}

export function getAIImgEvaluate(params) {
    return request({
        url: '/zhixue/getAIImgEvaluate',
        method: 'post',
        params: params
    })
}

export function evaluate(params) {
    return request({
        url: '/zhixue/evaluate',
        method: 'post',
        params: params
    })
}

export function reportTips(params) {
    return request({
        url: '/zhixue/tipsForText',
        method: 'post',
        params: params
    })
}

export function createApply(params) {
    return request({
        url: '/zhixue/createApply',
        method: 'post',
        data: params
    })
}

export function choiceAnswer(params) {
    return request({
        url: '/zhixue/choiceAnswer',
        method: 'post',
        data: params
    })
}

export function getPaperFatherInfo(params) {
    return request({
        url: '/zhixue/getPaperFatherInfo',
        method: 'post',
        params: params
    })
}

export function retryPaper(params) {
    return request({
        url: '/zhixue/retryPaper',
        method: 'post',
        params: params
    })
}

export function generateWrongPaper(params) {
    return request({
        url: '/zhixue/generateWrongPaper',
        method: 'post',
        params: params
    })
}


export function enable(params) {
    return request({
        url: '/zhixue/enable',
        method: 'post',
        params: params
    })
}

export function sendFreeVip(params) {
    return request({
        url: '/zhixue/sendFreeVip',
        method: 'post',
        params: params
    })
}

export function getHistoryOrder(params) {
    return request({
        url: '/zhixue/getHistoryOrder',
        method: 'post',
        params: params
    })
}

export function disable(params) {
    return request({
        url: '/zhixue/disable',
        method: 'post',
        params: params
    })
}

export function queryVipStatus(params) {
    return request({
        url: '/zhixue/queryVipStatus',
        method: 'post',
        params: params
    })
}

export function getLearnInfoByTime(params) {
    return request({
        url: '/zhixue/getLearnInfoByTime',
        method: 'post',
        params: params
    })
}

export function getLearnHistoryByMonth(params) {
    return request({
        url: '/zhixue/getLearnHistoryByMonth',
        method: 'post',
        params: params
    })
}

export function getImeiByPaperCode(params) {
    return new Promise((resolve, reject) => {
        request({
            url: '/zhixue/getImeiByPaperCode',
            method: 'post',
            params: params
        }).then(res => {
            resolve(res);
        })
    })
}

export function setWxSendTime(params) {
    return request({
        url: '/zhixue/setWxSendTime',
        method: 'post',
        params: params
    })
}

export function findReportAll(params){
    return request({
        url: '/zhixue/getWordLearnReport',
        method: 'post',
        params: params
    })
}

export function getOpenScreenInformation(params){
    return request({
        url: '/zhixue/getOpenScreenInformation',
        method: 'post',
        params: params
    })
}

export function getLearnReportOpenScreenInformation(params){
    return request({
        url: '/zhixue/getLearnReportOpenScreenInformation',
        method: 'post',
        params: params
    })
}


// WEBPACK FOOTER //
// ./src/api/zhixue.js